import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import "m2m-components/m2m-releases-link";
import { Outlet } from "react-router-dom";
import { AppHeader } from "../parts/AppHeader";
export const DefaultLayout = () => {
    return (_jsxs("div", { children: [_jsx(AppHeader, { controlls: _jsx("div", { children: _jsx("m2m-releases-link", { product: "matsuri-forms" }) }) }), _jsx(Outlet, {})] }));
};
